import request from '@/utils/request'

export function fetchCompanies(query) {
  return request({
    url: '/companies',
    method: 'get',
    params: query
  })
}

export function fetchCompanyList() {
  return request({
    url: '/companyList',
    method: 'get',
  })
}

export function fetchCompany(id) {
  return request({
    url: `/companies/${id}`,
    method: 'get'
  })
}


export function createCompany(data) {
  return request({
    url: '/companies',
    method: 'post',
    data
  })
}

export function updateCompany(id, data) {
  return request({
    url: `/companies/${id}`,
    method: 'put',
    data
  })
}


export function deleteCompany(id) {
  return request({
    url: `/companies/${id}`,
    method: 'delete'
  })
}